import { ThemeOptions } from '@material-ui/core/styles/createMuiTheme';

export const BASE_SERVER_URL: string =
    process.env.REACT_APP_ENV === 'production'
        ? 'https://paznic.app'
        : process.env.REACT_APP_ENV === 'staging'
            ? 'https://staging.paznic.app'
            : process.env.REACT_APP_ENV === 'test'
                ? 'https://test.paznic.app'
                : process.env.REACT_APP_ENV === 'development'
                    ? 'https://dev.paznic.app'
                    : process.env.REACT_APP_ENV === 'uitests'
                        ? '$BASE_URL'
                        : 'https://localhost:8001';

export const SCHEDULED_JOBS_SERVER_URL: string =
    process.env.REACT_APP_ENV === 'production'
        || process.env.REACT_APP_ENV === 'staging'
        || process.env.REACT_APP_ENV === 'test'
        || process.env.REACT_APP_ENV === 'development'
        || process.env.REACT_APP_ENV === 'uitests'
        ? BASE_SERVER_URL // proxied to the job-scheduler service under /api/ScheduledJobs
        : 'https://localhost:8002';

export const BLOB_STORAGE_URL: string =
    process.env.REACT_APP_ENV === 'production'
        ? 'https://paznic.app/content'
        : process.env.REACT_APP_ENV === 'staging'
            ? 'https://staging.paznic.app/content'
            : process.env.REACT_APP_ENV === 'test'
                ? 'https://test.paznic.app/content'
                : process.env.REACT_APP_ENV === 'development'
                    ? 'https://dev.paznic.app/content'
                    : 'https://ssamanagementuidev.blob.core.windows.net/public';



export const EULA_PDF_URL = `${BLOB_STORAGE_URL}/legal/eula.pdf`;
export const PRIVACY_POLICY_PDF_URL = `${BLOB_STORAGE_URL}/legal/privacypolicy.pdf`;
export const WHATS_NEW_PAGE_URL = "https://paznic.com/product-updates-3.html";

export const DEVICE_MANAGEMENT_LOGIN_HOST_PATH = "balena-devices.com/login";

export const UI_THEME: ThemeOptions = {
    palette: {
        primary: { main: '#3f51b5', light: '#0075ff' },
        secondary: { main: '#f50057' },
        error: { main: '#EA5047', light: '#F7E1E0', dark: '#c62828' },
        background: { default: '#f1f5f9', paper: '#ffffff', subtle: '#f8fafc' },
        text: { primary: '#0f172a', secondary: '#475569', disabled: '#94a3b8', hint: '#64748b' },
        divider: '#e2e8f0',
    },
    typography: {
        fontFamily: "'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    },
    // Legacy aliases — kept for backward compatibility
    backgroundThemeColor1: '#ffffff',
    backgroundThemeColor2: '#f1f5f9',
    fontThemeColor1: '#94a3b8',
    fontThemeColor2: '#475569',
    fontThemeColor3: '#0f172a',
    trimThemeColor1: '#3f51b5',
    dangerColor: '#EA5047',
};

export const LS_KEY_TAB_COUNT_AUTH_CONTROL = "tabCountAuthControl";
export const LS_KEY_DOMAIN_HINT = "domainHint";
export const LS_KEY_DOMAIN_HINT_ACCESS_EMAIL = "domainHintAccess_email";
export const LS_KEY_DOMAIN_HINT_ACCESS_HINT = "domainHintAccess_hint";
export const LS_KEY_REFRESH_TOKEN_UPDATED = "refreshTokenUpdated";
export const LS_KEY_REFRESH_TOKEN_EXP_DATE = "refreshTokenExpDate";
export const LS_KEY_REFRESH_TOKEN_LIFE_SECONDS = "refreshTokenLifeSeconds"
export const COOKIE_KEY_REFRESH_TOKEN = "refreshToken";

export const IDLE_TIMEOUT_ENABLED: boolean = true;
export const IDLE_TIMEOUT_FACTOR = 0.75;
export const IDLE_PROMPT_TIMEOUT_SECONDS: number = 30;
export const IDLE_TIMEOUT_MAX_SECONDS: number = 15 * 60;

export const SSO_DOMAIN: string =
    process.env.REACT_APP_ENV === 'production'
        ? 'login.paznic.com'
        : process.env.REACT_APP_ENV === 'staging'
            ? 'login.staging.paznic.com'
            : process.env.REACT_APP_ENV === 'test'
                ? 'login.test.paznic.com'
                : process.env.REACT_APP_ENV === 'development'
                    ? 'paznicdev.b2clogin.com'
                    : getSafeEnvVariableValue("REACT_APP_CUSTOM_SSO_DOMAIN"); // set any for development in .env

export const SSO_TENANT: string =
    process.env.REACT_APP_ENV === 'production'
        ? 'login.paznic.com'
        : process.env.REACT_APP_ENV === 'staging'
            ? 'staging.paznic.com'
            : process.env.REACT_APP_ENV === 'test'
                ? 'test.paznic.com'
                : process.env.REACT_APP_ENV === 'development'
                    ? 'paznicdev.onmicrosoft.com'
                    : getSafeEnvVariableValue("REACT_APP_CUSTOM_SSO_TENANT"); // set any for development in .env

export const SSO_SCOPE: string =
    process.env.REACT_APP_ENV === 'production'
        ? 'https://paznicproduction.onmicrosoft.com/management-api/ManagementApi.ReadWrite'
        : process.env.REACT_APP_ENV === 'staging'
            ? 'https://paznicstaging.onmicrosoft.com/management-api/ManagementApi.ReadWrite'
            : process.env.REACT_APP_ENV === 'test'
                ? 'https://paznictest.onmicrosoft.com/management-api/ManagementApi.ReadWrite'
                : process.env.REACT_APP_ENV === 'development'
                    ? 'https://paznicdev.onmicrosoft.com/pas-api-local-dev/ManagementAPI.ReadWrite'
                    : getSafeEnvVariableValue("REACT_APP_CUSTOM_SSO_SCOPE"); // set any for development in .env

export const SSO_CLIENT_ID: string =
    process.env.REACT_APP_ENV === 'production'
        ? '6d960bdf-e14c-4641-82a0-99ac37122af0'
        : process.env.REACT_APP_ENV === 'staging'
            ? '245ff3a9-e2ef-46ab-a301-0e42d0344264'
            : process.env.REACT_APP_ENV === 'test'
                ? '8cb18c2b-2616-4f2c-823c-fce75f613b87'
                : process.env.REACT_APP_ENV === 'development'
                    ? 'e137b1d9-e65f-4d7d-849a-8e51556f6e15'
                    : getSafeEnvVariableValue("REACT_APP_CUSTOM_SSO_CLIENT_ID"); // set any for development in .env

export const SSO_REDIRECT_URL: string =
    process.env.REACT_APP_CUSTOM_SSO_REDIRECT_URL
        ? process.env.REACT_APP_CUSTOM_SSO_REDIRECT_URL // set any for development in .env
        : BASE_SERVER_URL;

export const SSO_AUTHORITIES = {
    paznicCustom: `https://${SSO_DOMAIN}/${SSO_TENANT}/B2C_1A_PAZNICCUSTOMPOLICY`,
    changePassword: `https://${SSO_DOMAIN}/${SSO_TENANT}/B2C_1A_CHANGEPASSWORD`,
};

export const SSO_QS_KEY_ORIGIN = "origin"; // PAS-1255
export const SSO_QS_KEY_DOMAIN_HINT = "domain_hint"; // PAS-1810

function getSafeEnvVariableValue(envVariableName: string) {
    const value = process.env[envVariableName];
    return value ? value : `${envVariableName}_not_set`;
}
